import React from 'react'
import styles from "./ContactSupport.module.scss"

function ContactSupportCard({ image, text }) {
    return (
        <div>
            <img src={image} className={styles.img} />
            <div className={styles.container}>{text}</div>
        </div>
    )
}

export default ContactSupportCard
